/* eslint-disable react-refresh/only-export-components */
import { withSuspense } from '@/modules/global-components/ui/suspense/withSuspense';
import { lazy } from 'react';
import { Navigate } from 'react-router';

const CarrierDocuments = lazy(
  () => import('@/modules/utilities/carrierDocuments/carrierDocuments'),
);

const MultiExpense = lazy(
  () => import('@/modules/utilities/multi-expense/multiExpense'),
);

export const utilitiesRoutes = [
  {
    path: 'multi-docs',
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: withSuspense(CarrierDocuments),
      },
    ],
  },
  {
    path: 'multi-expense',
    element: withSuspense(MultiExpense),
  },
];
